import { Col } from 'antd'
import React from 'react'
import './Prices.css'

interface Props {
    colorPrice: string,
    price: string;
    descriptions: Array<string>;
    jobDescription: string;
    informationPrice: Array<string>
    imgParam: string;
}
const PriceCard: React.FC<Props> = ({ colorPrice = "#02B9EF", descriptions, informationPrice, jobDescription, price = "$150", imgParam }) => {
    return (
        <Col xs={24} sm={24} md={18} lg={10} xl={7} xxl={7} style={{ height: '95%', justifyContent: 'center', display: 'flex', flexDirection: 'column', marginBottom: '60px', width: '90%' }}>
            <div style={{ width: '100%', height: '10%', display: 'flex', justifyContent: 'center' }}>
                <div style={{
                    height: '100%',
                    width: '70%',
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                    backgroundColor: colorPrice,
                    position: 'relative'
                }}>
                    <div style={{
                        height: '120%',
                        width: "50%",
                        backgroundColor: 'white',
                        position: 'absolute',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        top: '-20px', borderRadius: 25, display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }} >
                        <img src={imgParam} style={{ height: '80%' }} alt="imgparam" />
                    </div>
                </div>
            </div>
            <div style={{ width: '100%', position: 'relative', backgroundColor: colorPrice, height: '90%', borderTopLeftRadius: 30, borderTopRightRadius: 30, borderBottomLeftRadius: 10, borderBottomRightRadius: 10, paddingBottom: '30px' }}>
                <div className='header-card'>
                    <span className="price">{price}</span>

                    {descriptions.map((item, index) => (
                        <span key={index} className="description">{item}</span>
                    ))}

                    <span className="description" style={{ bottom: '10px', position: 'absolute', }}>{jobDescription}</span>
                </div>

                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ width: '100%', paddingTop: '20px', paddingLeft: '20px', paddingRight: '20px', height: 'auto' }}>
                        {informationPrice.map((item, index) => (
                            <div key={index} style={{ width: '100%', display: "flex", flexDirection: 'row', paddingBottom: '10px', alignItems: 'center' }}>
                                <div style={{ height: '30px', width: '30px', backgroundColor: 'white', borderRadius: "50%", display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: '20px' }}>
                                    <span style={{ fontSize: '14px', color: "green", fontWeight: 'bold' }}>√</span>
                                </div>
                                <span className='information-price'>{item}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Col>
    )
}

export default PriceCard
